import { Property, Type } from '@dipscope/type-manager';
import { Color } from '../../core/Player';

@Type({
  discriminant: 'KResource',
  injectable: true
})
export class KResource {
  @Property()
  id: number;
  @Property()
  playerId: number;
  @Property()
  type: string;
  @Property()
  value: number = 2;
  @Property()
  color: Color;
  @Property()
  harvested: boolean = false;
  @Property()
  nodeId?: number;
  @Property()
  tileId?: number;
  @Property()
  score: number = 0;
  moved: boolean = false;
}
@Type({
  discriminant: 'KPlayerResource',
  injectable: true
})
export class KPlayerResource {
  @Property([Number, KResource])
  map: Map<number, KResource> = new Map();
}
